// skeleton/app/src/app/dashboard-reports/dashboard-reports.component.ts

import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { Constants } from '../shared/constants';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { Chart, ChartDataset } from 'chart.js';
import { baseColors } from 'ng2-charts';
import { OrganizationModel } from '../admin/models/organization.model';
import { GroupModel } from '../admin/models/group.model';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { StorageService } from '../shared/services/token-storage.service';

@Component({
  selector: 'app-dashboard-reports',
  templateUrl: './dashboard-reports.component.html',
  styleUrls: ['./dashboard-reports.component.scss'],
  standalone: false,
  animations: [
    trigger('flipState', [
      state('active', style({
        transform: 'rotateY(179deg)'
      })),
      state('inactive', style({
        transform: 'rotateY(0)'
      })),
      transition('active => inactive', animate('500ms ease-out')),
      transition('inactive => active', animate('500ms ease-in'))
    ])
  ]
})
export class DashboardReportsComponent {
  userName: string = "";
  userId: string = "";
  constants: Constants = new Constants();
  total: string = "";
  open: string = "";
  average: string = "";
  labeldata: any[] = [];
  realdata: any[] = [];
  colordata: any[] = [];
  orgs: OrganizationModel[] = [];
  groupId: any;
  selectedGroupId: any;

  dashboardReportData: DashboardReportData = new DashboardReportData();
  businessProcessSeverityData: BusinessProcessSeverity = new BusinessProcessSeverity();
  severityTypeCount: SeverityTypeCount[];

  OpenClosedLabels: string[] = [];
  OpenIncidentsData: number[] = [];
  ClosedIncidentsData: number[] = [];

  flip1: string = 'inactive';
  flip2: string = 'inactive';
  flip3: string = 'inactive';
  flip4: string = 'inactive';

  isChartData1 = false;
  isDueDateTableLoaded = false;
  isToDisplayLinechartData: boolean = true;

  dataSource1 = new MatTableDataSource<DashboardReportData>();
  dataSource2 = new MatTableDataSource<DashboardReportData>();
  IncidentAgedataSource = new MatTableDataSource<BusinessProcessSeverity>();
  SeveritydataSource = new MatTableDataSource<BusinessProcessSeverity>();

  displayedColumns: string[] = ['incident', 'incidentCount'];
  displayedColumns3: string[] = ['BPName', 'severityType', 'severityCount'];
  displayedColumns1: string[] = ['column11', 'column22', 'column33'];
  displayedColumns2: string[] = ['incidentName', '0to30days', '31to60days', 'others'];

  @ViewChild('timelinePaginator') paginator1: MatPaginator;
  @ViewChild('timelineSort') sort1: MatSort;

  @ViewChild('incidentsPaginator') paginator2: MatPaginator;
  @ViewChild('incidentsSort') sort2: MatSort;

  @ViewChild('severityPaginator') paginator3: MatPaginator;
  @ViewChild('severitySort') sort3: MatSort;

  @ViewChild('ageingPaginator') paginator4: MatPaginator;
  @ViewChild('ageingSort') sort4: MatSort;

  pageSize: number = 5;
  pageIndex: number = 0;

  incidentAge: number[] = [];
  incidentAgeCategory: string[] = [];
  businessProcessNamesArray: string[] = [];

  constructor(
    private baseHttpService: BaseHttpService,
    private cdr: ChangeDetectorRef,
    private storage: StorageService
  ) { }

  ngOnInit() {
    this.getDashboardReports();
    //this.getAverageResolutionTime();
    this.getSeverityData();
    this.GetLoggedinUserDetails();
  }

  getDashboardReports() {
    this.baseHttpService.get(this.constants.getDashboardReportData).subscribe((result) => {
      if (result != null) {
        this.dashboardReportData = result;
        console.log(this.dashboardReportData);
        this.total = result.totalIncidents;
        this.open = result.totalOpenIncidents;
        this.OpenClosedLabels = this.dashboardReportData.businessProcessNames;
        this.OpenIncidentsData = this.dashboardReportData.totalOpenIncidentsArray;
        this.ClosedIncidentsData = this.dashboardReportData.closedIncidentsArray;
        this.cdr.detectChanges();
      }
    });
  }

  getAverageResolutionTime() {
    this.baseHttpService.get(this.constants.getAverageResolutionTime).subscribe((result) => {
      if (result != null) {
        this.dashboardReportData = result;
        console.log(this.dashboardReportData);
        this.average = result;
      }
    });
  }

  getSeverityData() {
    this.baseHttpService.get(this.constants.getDashboardReportSeverityData).subscribe((result) => {
      if (result != null) {
        this.businessProcessSeverityData = result;

        this.businessProcessSeverityData.SeverityBPName = [];
        this.businessProcessSeverityData.SeverityMinorCount = [];
        this.businessProcessSeverityData.SeverityMajorCount = [];

        if (this.businessProcessSeverityData && this.businessProcessSeverityData.severityTypeCounts) {
          this.businessProcessSeverityData.severityTypeCounts.forEach(data => {
            this.businessProcessSeverityData.SeverityMinorCount.push(data.minorCount);
            this.businessProcessSeverityData.SeverityMajorCount.push(data.majorCount);
            this.businessProcessSeverityData.SeverityBPName.push(data.businessProcessName);
          });
        }

        if (this.businessProcessSeverityData && this.businessProcessSeverityData.incidentAges) {
          const uniqueBusinessProcessData: any = {};

          // Initialize structure for each unique business process name
          this.businessProcessSeverityData.incidentAges.forEach(data => {
            const { businessProcessName } = data;
            if (!uniqueBusinessProcessData[businessProcessName]) {
              uniqueBusinessProcessData[businessProcessName] = {
                data0to30days: 0,
                data31to60days: 0,
                dataothers: 0
              };
            }
          });

          // Populate structure with incidentAges
          this.businessProcessSeverityData.incidentAges.forEach(data => {
            const { ageCategory, count, businessProcessName } = data;
            if (ageCategory === '0-30 days') {
              uniqueBusinessProcessData[businessProcessName].data0to30days += count;
            } else if (ageCategory === '31-60 days') {
              uniqueBusinessProcessData[businessProcessName].data31to60days += count;
            } else {
              uniqueBusinessProcessData[businessProcessName].dataothers += count;
            }
          });

          // Clear existing arrays
          this.businessProcessSeverityData.data0to30days = [];
          this.businessProcessSeverityData.data31to60days = [];
          this.businessProcessSeverityData.dataothers = [];
          this.businessProcessSeverityData.businessProcessNamesforAge = [];

          // Update chart arrays
          for (const businessProcessName in uniqueBusinessProcessData) {
            this.businessProcessSeverityData.businessProcessNamesforAge.push(businessProcessName);
            this.businessProcessSeverityData.data0to30days.push(uniqueBusinessProcessData[businessProcessName].data0to30days);
            this.businessProcessSeverityData.data31to60days.push(uniqueBusinessProcessData[businessProcessName].data31to60days);
            this.businessProcessSeverityData.dataothers.push(uniqueBusinessProcessData[businessProcessName].dataothers);
          }
        }
      }
    });
  }

  setGridData(filteredResult: DashboardReportData[]) {
    this.dataSource1 = new MatTableDataSource(filteredResult);
    this.dataSource1.paginator = this.paginator1;
    this.dataSource1.sort = this.sort1;

    let dataRows = [];
    for (let i = 0; i < this.dashboardReportData.incidentsByWeeks.length; i++) {
      dataRows.push({
        incidentsByWeeks: this.dashboardReportData.incidentsByWeeks[i],
        totalIncidentsByWeeks: this.dashboardReportData.totalIncidentsByWeeks[i]
      });
    }
    this.dataSource1.data = dataRows;
  }

  setGridData1(filteredResult: DashboardReportData[]) {
    this.dataSource2 = new MatTableDataSource(filteredResult);
    this.dataSource2.paginator = this.paginator2;
    this.dataSource2.sort = this.sort2;

    let dataRows = [];
    for (let i = 0; i < filteredResult.length; i++) {
      for (let j = 0; j < filteredResult[i].businessProcessNames.length; j++) {
        const rowData = {
          businessProcessNames: filteredResult[i].businessProcessNames[j],
          totalOpenIncidentsArray: filteredResult[i].totalOpenIncidentsArray[j],
          closedIncidentsArray: filteredResult[i].closedIncidentsArray[j]
        };
        dataRows.push(rowData);
      }
    }
    this.dataSource2.data = dataRows;
  }

  setSeverityData(filteredResult: BusinessProcessSeverity[]) {
    this.SeveritydataSource = new MatTableDataSource(filteredResult);
    this.SeveritydataSource.paginator = this.paginator3;
    this.SeveritydataSource.sort = this.sort3;

    let dataRows = [];
    for (let i = 0; i < this.businessProcessSeverityData.severityTypeCounts.length; i++) {
      dataRows.push({
        minorCount: this.businessProcessSeverityData.severityTypeCounts[i].minorCount,
        majorCount: this.businessProcessSeverityData.severityTypeCounts[i].majorCount,
        businessProcessName: this.businessProcessSeverityData.severityTypeCounts[i].businessProcessName
      });
    }
    this.SeveritydataSource.data = dataRows;
  }

  setIncidentAgeGridData(filteredResult: BusinessProcessSeverity[]) {
    this.IncidentAgedataSource = new MatTableDataSource(filteredResult);
    this.IncidentAgedataSource.paginator = this.paginator4;
    this.IncidentAgedataSource.sort = this.sort4;

    let dataRows = [];
    for (let result of filteredResult) {
      for (let i = 0; i < result.businessProcessNamesforAge.length; i++) {
        dataRows.push({
          businessProcessNamesforAge: result.businessProcessNamesforAge[i],
          data0to30days: result.data0to30days[i],
          data31to60days: result.data31to60days[i],
          dataOthers: result.dataothers[i]
        });
      }
    }

    this.IncidentAgedataSource.data = dataRows;
    console.log(this.IncidentAgedataSource);
  }

  handlePageEvent(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
  }

  toggleFlip1() {
    //debugger;
    this.flip1 = (this.flip1 == 'inactive') ? 'active' : 'inactive';
    this.isToDisplayLinechartData = !this.isToDisplayLinechartData;
    this.setGridData([this.dashboardReportData]);
  }

  toggleFlip2() {
    //debugger;
    this.flip2 = (this.flip2 == 'inactive') ? 'active' : 'inactive';
    this.setGridData1([this.dashboardReportData]);
  }

  toggleFlip3() {
    //debugger;
    this.flip3 = (this.flip3 == 'inactive') ? 'active' : 'inactive';
    this.isToDisplayLinechartData = !this.isToDisplayLinechartData;
    this.setSeverityData([this.businessProcessSeverityData]);
  }

  toggleFlip4() {
    //debugger;
    this.flip4 = (this.flip4 == 'inactive') ? 'active' : 'inactive';
    this.isToDisplayLinechartData = !this.isToDisplayLinechartData;
    this.setIncidentAgeGridData([this.businessProcessSeverityData]);
  }

  GetLoggedinUserDetails() {
    this.baseHttpService.get(this.constants.getUser).subscribe(result => {
      if (result != null) {
        this.userId = result.customerId;
        let loginname = result.fullName.split(",");
        this.userName = loginname[1];

        //  Use StorageService instead of sessionStorage
        this.storage.set("OrganizationId", result.organizationId);
      }
    });
  }
}

export class DashboardReportData {
  totalIncidents: number;
  totalOpenIncidents: number;
  businessProcessData: BusinessProcessData[];
  closedIncidentsArray: number[];
  totalOpenIncidentsArray: number[];
  businessProcessNames: string[];
  incidentsByWeeks: string[];
  totalIncidentsByWeeks: number[];
  incidentAge: any[];
}

export class BusinessProcessData {
  idnGroupMaster: string;
  idnBusinessProcess: string;
  createdByUser: string;
  businessProcessName: string;
  businessProcessInstanceCount: number;
  surveyCount: number;
  status: string;
  totalIncidents: number;
  totalOpenIncidents: number;
  totalIncidentsCreatedByUser: number;
  totalOpenIncidentsCreatedByUser: number;
  closedIncidentsCreatedByUser: number;
}

export class SeverityTypeCount {
  businessProcessName: string;
  majorCount: number;
  minorCount: number;
}

export class IncidentAgeCount {
  ageCategory: string;
  businessProcessName: string;
  count: number;
}

export class BusinessProcessSeverity {
  severityTypeCounts: SeverityTypeCount[];
  businessProcessNamesforAge: string[];
  incidentAges: IncidentAgeCount[];
  data0to30days: number[];
  data31to60days: number[];
  dataothers: number[];
  SeverityMinorCount: number[];
  SeverityMajorCount: number[];
  SeverityBPName: string[];
}
